import React from 'react';

interface LoadingSpinnerProps {
    isBackground?: boolean;
    height?: number;
    width?: number;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ isBackground = true, height = 12, width = 12 }) => {
    return (
        <div className={isBackground ? "fixed inset-0 bg-gray-100 bg-opacity-75 flex justify-center items-center z-50" : "flex justify-center items-center z-50"}>
            <div className={"animate-spin rounded-full h-" + height + " w-" + width + " border-4 border-gray-300 border-t-orange-500"}></div>
        </div>
    );
};

export default LoadingSpinner;
